import React from "react"
import strings from "../../../localization/strings"
import { IScheduleDocument } from "../../../models"
import { Dialog, FlatButton } from "material-ui"
import moment from "moment"
import { amber500 } from "material-ui/styles/colors"
import * as timeHelper from "../../../helpers/timeHelper"

interface IProps {
  schedule: IScheduleDocument
  handlePostSchedule(schedule: IScheduleDocument): void
  handleClose(): void
}

const PostScheduleConfirmDialog: React.SFC<IProps> = (props: IProps) => {
  const totalShiftsCount = props.schedule.Schedules.length
  const unfilledShiftsCount = props.schedule.Schedules.filter(pt => !pt.AssignedUserId).length
  const filledPercent = Math.round((totalShiftsCount - unfilledShiftsCount) * 100 / totalShiftsCount)
  let employeeIds: string[] = []
  props.schedule.Schedules.forEach(pt =>
    pt.AssignedUserId && !employeeIds.find((id) => id === pt.AssignedUserId) && employeeIds.push(pt.AssignedUserId)
  )

  return (
    <Dialog
      open
      title={`${strings.Post_Schedule}: ${props.schedule.Name}`}
      titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
      actions={[
        <FlatButton
          data-intercom-target={"Schedules-Btn-ClosePostScheduleConfirmDialog"}
          label={strings.CANCEL}
          secondary
          onClick={props.handleClose}
        />,
        <FlatButton
          data-intercom-target={"Schedules-Btn-Save"}
          label={strings.SAVE}
          primary
          onClick={() => props.handlePostSchedule(props.schedule)}
        />
      ]}
    >
      <div style={{ paddingRight: 20, paddingLeft: 20, paddingTop: 20 }}>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, color: amber500 }}>
            <div style={{ textAlign: "center", fontSize: 60 }}><i className="fa fa-calendar" /></div>
            <div style={{ textAlign: "center", fontSize: 40 }}><i className="fa fa-arrow-right" /></div>
          </div>
          <div style={{ flex: 4 }}>
            <div style={{ padding: 5 }}>{`${strings.Date}: ${moment(timeHelper.keepConvertUTCToLocal(props.schedule.StartDate)).format("ddd MMM. DD, YYYY")} - ${moment(timeHelper.keepConvertUTCToLocal(props.schedule.EndDate)).format("ddd MMM. DD, YYYY")}`}</div>
            {filledPercent !== 100 &&
              <div style={{ padding: 5 }}>{strings.You_arent_filled}</div>
            }
            <div style={{ padding: 5 }}>{filledPercent === 100 ? strings.Are_you_sure_you_want_to_post_this_schedule : strings.Are_you_sure_you_want_to_post_this_schedule_anyway}</div>
            <div style={{ padding: 5 }}>
              {strings.formatString(
                employeeIds.length === 1 ? strings.employee_will_be_alerted_once_the_schedule_is_posted : strings.employees_will_be_alerted_once_the_schedule_is_posted,
                employeeIds.length
              )}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default PostScheduleConfirmDialog

